export default __webpack_public_path__ + "static/media/portfolio.e4d369bc.png";